export const RADIO = "radio";
export const LINK = "link";
export const CHECKBOX = "checkbox";
export const NONE = "none";
